import styled, {
  css,
  ThemedStyledProps,
  FlattenInterpolation,
  SimpleInterpolation,
} from 'styled-components';

import { GlobalThemeType } from '../../../themes/types';
import { flexDirection, webkitOverflowFix } from '../../../utils/boxProps';
import { extractProp, extractBooleanProps } from '../../../utils/extractProps';
import {
  PROP_NAMES,
  HOVER_PROP_NAMES,
  NON_BASE_PROPS,
  BOOLEAN_PROPS,
  BooleanProps,
} from '../constants';
import { BoxPropsWithTheme } from '../types';

export const defaultBoxStyleProps = (
  theme: GlobalThemeType,
): {
  propNames: string[];
  hoverPropNames: string[];
  nonBaseProps: string[];
  booleanProps: BooleanProps;
} => ({
  propNames: PROP_NAMES,
  hoverPropNames: HOVER_PROP_NAMES,
  nonBaseProps: NON_BASE_PROPS,
  booleanProps: BOOLEAN_PROPS(theme),
});

export const BoxStyle = (
  props: BoxPropsWithTheme,
  boxStyleProps: typeof defaultBoxStyleProps = defaultBoxStyleProps,
): FlattenInterpolation<ThemedStyledProps<undefined, undefined>> => {
  const { booleanProps, propNames, nonBaseProps, hoverPropNames } =
    boxStyleProps(props.theme);

  return css`
    display: ${props.display || 'flex'};
    position: ${props.position || 'relative'};
    flex-direction: ${flexDirection(props)};
    min-height: 0;
    min-width: 0;
    background-color: transparent;
    color: ${props.defaultColor ? props.theme.text.primary : 'inherit'};
    cursor: ${props.onClick ? 'pointer' : 'inherit'};

    ${extractBooleanProps(props, booleanProps)};
    ${webkitOverflowFix(props)};

    ${propNames
      .map(propName => extractProp(propName, props, false, nonBaseProps))
      .join('')};

    &:hover {
      ${hoverPropNames
        .map(propName => extractProp(propName, props, true, nonBaseProps))
        .join('')};
    }

    ${(props.css || '') as SimpleInterpolation};
  `;
};

export default styled.div<BoxPropsWithTheme>`
  ${
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    BoxStyle
  };
`;
